import { useEffect } from 'react';
import type { QnAStateType } from '@uber/react-qna-lib';
import { useFetchQuestionnaire } from '../../modernization-common/side-panel/hooks/use-questionnaire';
type UseQuestionnairePrefetchProps = {
  questionnaireIds: string[];
  fetchQuestionnaire?: (questionnaire: string) => Promise<QnAStateType>;
};
export const useQuestionnairePrefetch = ({
  questionnaireIds,
  fetchQuestionnaire
}: UseQuestionnairePrefetchProps) => {
  const fetchAndCache = useFetchQuestionnaire({
    fetchQuestionnaire
  });
  useEffect(() => {
    const prefetchQuestionnaires = async () => {
      if (!fetchQuestionnaire || questionnaireIds.length === 0) return;
      const uniqueQuestionnaireIds = new Set(questionnaireIds.filter(Boolean));
      await Promise.allSettled(Array.from(uniqueQuestionnaireIds).map(id => fetchAndCache(id)));
    };
    prefetchQuestionnaires();
  }, [questionnaireIds, fetchQuestionnaire, fetchAndCache]);
};